import { Box, styled } from '@mui/material'

export const StyledContainer = styled(Box)<{ $isHighlighted: boolean }>`
  ${({ $isHighlighted }) =>
    $isHighlighted
      ? `
          background-color: #d1e8f5;
          padding: 10px 6px 10px 10px;
        `
      : ''};
`
